/**
 * Print-configuration ("product options") types.
 *
 * Ported from the pilot's `types/selectors.ts` and kept deliberately close to it: the wire
 * format is shared with the backend prompt and with sessions already persisted in production,
 * so the shapes are not ours to tidy up. See `parseReply.ts` for the one place that matters.
 */

export const PRINT_OPTIONS_CHOICE_CUSTOMER = 'CUSTOMER' as const;
export const PRINT_OPTIONS_CHOICE_DESIGNER = 'DESIGNER' as const;

export type PrintOptionsChoice =
    | typeof PRINT_OPTIONS_CHOICE_CUSTOMER
    | typeof PRINT_OPTIONS_CHOICE_DESIGNER;

/** One selectable value of a print option, as returned by `printProductConfigurator`. */
export type PrintOptionValue = {
    key: string;
    name: string;
    isCompatible: boolean;
    imageUrl?: string;
};

/** One print option (e.g. "Shape", "Paper Stock") and the values available for it. */
export type PrintOption = {
    key: string;
    name: string;
    values: PrintOptionValue[];
};

/**
 * A selected option rendered in the answered message: display names rather than keys, resolved
 * at submit time from the option list that was on screen.
 *
 * Resolved eagerly rather than looked up on render because the answered bubble outlives the
 * query — re-resolving names later would mean refetching the configurator for every historical
 * message in the thread.
 */
export type PrintOptionSelectionDetail = {
    optionName: string;
    valueName: string;
    imageUrl?: string;
};

/** Attribute key/value pairs sent back to the configurator to drive compatibility filtering. */
export type SelectedAttribute = {
    attributeKey: string;
    valueKey: string;
};
